import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, Button, IconButton,
  Drawer, List, ListItem, ListItemText,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useMediaQuery } from '@mui/material';
import { useAuth } from './AuthContext';

function Navbar() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated, logout } = useAuth();

  const closeMenu = () => setIsMenuOpen(false);

  const handleLogout = () => { logout(); closeMenu(); };

  return (
    <AppBar position="static">
      <Toolbar>
        {isMobile && (
          <IconButton color="inherit" aria-label="Menu" onClick={() => setIsMenuOpen(true)}>
            <MenuIcon />
          </IconButton>
        )}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Emerich Custom Build
        </Typography>
        {!isMobile && (
          <>
            <Button color="inherit"><Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>Home</Link></Button>
            <Button color="inherit"><Link to="/portfolio" style={{ textDecoration: 'none', color: 'inherit' }}>Portfolio</Link></Button>
            <Button color="inherit"><Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>Contact</Link></Button>
            {isAuthenticated && (
              <>
                <Button color="inherit"><Link to="/dashboard" style={{ textDecoration: 'none', color: 'inherit' }}>Dashboard</Link></Button>
                <Button color="inherit" onClick={handleLogout}>Logout</Button>
              </>
            )}
          </>
        )}
      </Toolbar>
      <Drawer anchor="left" open={isMenuOpen} onClose={closeMenu}>
        <div role="presentation" onClick={closeMenu} onKeyDown={closeMenu} style={{ width: '200px' }}>
          <List>
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}><ListItem button><ListItemText primary="Home" /></ListItem></Link>
            <Link to="/portfolio" style={{ textDecoration: 'none', color: 'inherit' }}><ListItem button><ListItemText primary="Portfolio" /></ListItem></Link>
            <Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}><ListItem button><ListItemText primary="Contact" /></ListItem></Link>
            {isAuthenticated && (
              <>
                <Link to="/dashboard" style={{ textDecoration: 'none', color: 'inherit' }}><ListItem button><ListItemText primary="Dashboard" /></ListItem></Link>
                <ListItem button onClick={handleLogout}><ListItemText primary="Logout" /></ListItem>
              </>
            )}
          </List>
        </div>
      </Drawer>
    </AppBar>
  );
}

export default Navbar;
